import type { CatBaseSprite, CatId, CatRarity } from "../types";

export type CatDefinition = {
  id: CatId;
  name: string;
  breed: string;
  price: number;
  furColor: string;
  appearance: string;
  personality: string;
  rarity: CatRarity;
  baseSprite: CatBaseSprite;
  tint: number;
  home: { x: number; y: number; cellX: number; cellY: number };
  roam: Array<{ x: number; y: number }>;
};

export const CATS: Record<CatId, CatDefinition> = {
  mali: {
    id: "mali", name: "มะลิ", breed: "แร็กดอลล์", price: 720,
    furColor: "ครีมแต้มช็อกโกแลต", appearance: "ขนยาวนุ่ม ตาสีฟ้า", personality: "อ่อนโยนและขี้อ้อน",
    rarity: "common", baseSprite: "mali", tint: 0xffffff,
    home: { x: 430, y: 365, cellX: 5, cellY: 6 },
    roam: [{ x: 415, y: 360 }, { x: 470, y: 390 }, { x: 515, y: 430 }],
  },
  khram: {
    id: "khram", name: "คราม", breed: "โคราช", price: 1_050,
    furColor: "เทาเงิน", appearance: "ขนฟู ตากลมสีอำพัน", personality: "ช่างสงสัยและชอบสำรวจ",
    rarity: "uncommon", baseSprite: "khram", tint: 0xffffff,
    home: { x: 700, y: 565, cellX: 7, cellY: 5 },
    roam: [{ x: 650, y: 545 }, { x: 720, y: 585 }, { x: 780, y: 625 }],
  },
  fai: {
    id: "fai", name: "ฝ้าย", breed: "Domestic Longhair", price: 1_350,
    furColor: "ส้มขาว", appearance: "ขนยาวฟู ลายส้มขาว", personality: "ร่าเริงและรักการงีบ",
    rarity: "uncommon", baseSprite: "fai", tint: 0xffffff,
    home: { x: 1_035, y: 520, cellX: 7, cellY: 7 },
    roam: [{ x: 990, y: 520 }, { x: 1_050, y: 555 }, { x: 970, y: 610 }],
  },
  dao: {
    id: "dao", name: "ดาว", breed: "Turkish Angora", price: 1_750,
    furColor: "ขาวนวล", appearance: "ขนยาวสีขาว หางพวง", personality: "สง่างามและรักความสะอาด",
    rarity: "rare", baseSprite: "mali", tint: 0xfff9f0,
    home: { x: 560, y: 430, cellX: 6, cellY: 6 },
    roam: [{ x: 520, y: 420 }, { x: 590, y: 455 }, { x: 645, y: 485 }],
  },
  mek: {
    id: "mek", name: "เมฆ", breed: "British Shorthair", price: 2_300,
    furColor: "ซิลเวอร์บลู", appearance: "ขนสั้นแน่น หน้ากลม", personality: "ใจเย็นและติดบ้าน",
    rarity: "rare", baseSprite: "khram", tint: 0xcfe1f2,
    home: { x: 875, y: 605, cellX: 8, cellY: 6 },
    roam: [{ x: 835, y: 590 }, { x: 905, y: 625 }, { x: 945, y: 660 }],
  },
  manao: {
    id: "manao", name: "มะนาว", breed: "Golden Fantasy", price: 3_200,
    furColor: "ทองพีช", appearance: "ขนฟูประกายทอง หางใหญ่", personality: "สดใสและนำโชค",
    rarity: "legendary", baseSprite: "fai", tint: 0xffd27d,
    home: { x: 1_070, y: 650, cellX: 8, cellY: 7 },
    roam: [{ x: 1_020, y: 630 }, { x: 1_095, y: 675 }, { x: 1_145, y: 705 }],
  },
};

export const CAT_IDS = Object.keys(CATS) as CatId[];
export const CAT_RARITY_LABEL: Record<CatRarity, string> = {
  common: "ทั่วไป",
  uncommon: "พิเศษ",
  rare: "หายาก",
  legendary: "ตำนาน",
};
